<template>
	<div class="scene-bar" >
		<div class="scene-list">
			<div v-for="(item,index) in workDetail.sceneList" :key="item.id" class="item" :class="{active:item.id == materialId}">
				<div v-if="item.status == 1" class="thumb-box-placeholder">转码中...</div>
				<div v-if="item.status == 2" class="thumb-box" @click="changeScene(item.id,index)">
					<img class="thumb" :src="item.thumbPreview">
				</div>
				<div class="footer">
					<div class="sort">【{{ item.sort || 0 }}】</div>
					<div class="name v-ellipsis" :title="item.name">{{ item.name }}</div>
					<div class="operator">
						<i title="编辑" class="icon el-icon-edit" @click="editScene(item)"></i>
						<el-popconfirm v-if="isShowDelete(item)" :class="{hide:worksType == 3 && groupList.length > 1 }" title="确认删除？" @onConfirm="doDelete(item)">
							<i slot="reference" title="删除" class="icon el-icon-delete"></i>
						</el-popconfirm>
					</div>
				</div>
			</div>
			<div class="scene-add-btn" :class="{hide:!isShowAddScene}"  @click="isShowSceneAdd = true">
				<i class="icon el-icon-plus"></i>
				<div class="txt">添加场景</div>
			</div>
		</div>
		<scene-bar-edit v-if="isShowSceneEdit" :show.sync="isShowSceneEdit" :row="row" />
		<scene-bar-add v-if="isShowSceneAdd" :show.sync="isShowSceneAdd" />
	</div>
</template>

<script>
	import {mapState, mapMutations, mapActions} from 'vuex';
	import sceneBarEdit from './scene-bar-edit'
	import sceneBarAdd from './scene-bar-add'

	export default {

		components: {sceneBarEdit, sceneBarAdd},

		data() {
			return {
				isShowSceneEdit: false,
				isShowSceneAdd: false,
				worksType: this.$route.query.type,
				row: null,
				sceneIndex:0,
			}
		},

		computed: {
			...mapState('tour', ['materialId', 'krp', 'sceneDetail', 'workDetail','activeGroupId','groupList','isCompareView']),
      isShowAddScene(){
				return this.worksType == 1 || (this.worksType == 3 && this.groupList && this.groupList.length && this.activeGroupId == this.groupList[0].id)
      }
		},

		async created() {
			if(this.worksType == 1){
				await this.getWorksDetail();
				this.initKrpPano();
			}
		},

		watch:{
			async activeGroupId(){
				await this.getWorksDetail();
				if(!this.krp){
					this.initKrpPano();
				}else{
					await this.actionGetSceneDetail({materialId: this.materialId});
					this.actionLoadKrp({krp: this.krp, sceneDetail: this.sceneDetail});
				}
			},
		},


		methods: {

			...mapMutations("tour", {
				mutationSetMaterialId: "SET_MATERIAL_ID",
				mutationUpdateIsShowViwer: "UPDATE_IS_SHOW_VIWER"
			}),

			...mapActions("tour", {
				actionGetSceneDetail: "getSceneDetail",
				actionGetWorksDetail: "getWorksDetail",
				actionGetKrpInstance: "getKrpInstance",
				actionLoadKrp: "loadKrp"
			}),

			async getWorksDetail() {
				try {
					let res = await this.actionGetWorksDetail({worksId: this.$route.query.id,groupId:this.activeGroupId});
					let scene = res.data.sceneList[this.sceneIndex]
					let materialId = scene && scene.status == 2 ? scene.id : res.data.sceneList.filter(item => item.status == 2)[0].id
					this.mutationSetMaterialId(materialId);
					return res
				} catch (e) {
					console.error(e)
				}
			},

			async initKrpPano() {
				await this.actionGetSceneDetail({materialId: this.materialId});
				await this.actionGetKrpInstance("pano");
				this.actionLoadKrp({krp: this.krp, sceneDetail: this.sceneDetail});
			},

			//切换场景
			async changeScene(materialId,index) {
				if (materialId == this.materialId) {
					return
				}
				this.mutationUpdateIsShowViwer(false);
				this.sceneIndex = index;
				this.mutationSetMaterialId(materialId);
				await this.actionGetSceneDetail({materialId: this.materialId});
				this.actionLoadKrp({krp: this.krp, sceneDetail: this.sceneDetail});
			},

			editScene(row) {
				this.row = row;
				this.isShowSceneEdit = true;
			},

			isShowDelete(row) {
				return !(row.status == 2 && this.workDetail.sceneList.filter(item => item.status == 2).length == 1)
			},

			async doDelete(row) {
				this.$set(row, "deleteLoading", true);
				try {
					await this.api.material.delete({id: row.id});
					await this.actionGetWorksDetail({worksId: this.$route.query.id});
					if (row.id == this.materialId) {
						this.mutationUpdateIsShowViwer(false);
						let materialId = this.workDetail.sceneList.filter(item => item.status == 2)[0].id
						this.mutationSetMaterialId(materialId);
						await this.actionGetSceneDetail({materialId});
						this.actionLoadKrp({krp: this.krp, sceneDetail: this.sceneDetail});
					}
					this.$message.success("删除成功");
				} catch (e) {
					console.error(e);
				}
				this.$set(row, "deleteLoading", false);
			},
		}
	}
</script>

<style scoped>
	.scene-bar {
		position: absolute;
		top: 52px;
		bottom: 0;
		transform: translateZ(1px);
		background: rgba(0, 0, 0, 0.6);
		color: #fff;
		padding: 0 15px;
		width: 124px;
		overflow-y: auto;
		padding-bottom: 15px;
	}

	.hide-cover{
		opacity: 0.5;
	}

	.scene-list {
		position: relative;
	}

	.scene-list .item {
		width: 120px;
		margin-top: 15px;
		border: 2px solid #fff;
		overflow: hidden;
	}

	.scene-list .item.active {
		border-color: #fbd14b;
	}

	.scene-list .thumb-box {
		width: 100%;
		height: 60px;
		position: relative;
		overflow: hidden;
		cursor: pointer;
	}

	.scene-list .thumb-box-placeholder {
		width: 120px;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		background: #404040;
	}

	.scene-list .thumb {
		display: block;
		width: 100%;
		position: absolute;
		top: 50%;
		left: 0;
		transform: translateY(-50%);
	}

	.scene-list .footer {
		display: flex;
		align-items: center;
		height: 24px;
		font-size: 12px;
		padding-right: 5px;
	}

	.scene-list .name {
		flex: 1;
	}

	.scene-list .footer i {
		margin-left: 5px;
		cursor: pointer;
		font-weight: bold;
	}

	.scene-add-btn {
		height: 60px;
		width: 124px;
		border: 1px dashed #9a9a9a;
		border-radius: 4px;
		cursor: pointer;
		color: #9a9a9a;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		font-size: 12px;
		user-select: none;
		flex-shrink: 0;
		margin: 15px auto 0 auto;
	}

	.scene-add-btn .icon {
		font-size: 16px;
	}
	.hide{
		display: none!important;
	}
</style>